<template>
  <div class="replacementmonthlystatistics__report__view">
    <div class="reports__subheader">

      <year-panel @year="(value) => year = value">
      </year-panel>

      <submit-panel @submit="performLookup">
      </submit-panel>
    </div>

   
    <b-table :data="agreements"
             :loading="loading"
             @click="editClick"
             hoverable>

      <b-table-column field="employee.number"
                      label="Nr."
                      searchable
                      v-slot="props">
        {{ props.row.employee.number }}
      </b-table-column>
      <b-table-column field="employeeName"
                      label="Navn"
                      searchable
                      v-slot="props">
        {{ props.row.employeeName }}
      </b-table-column>
      
      <b-table-column field="daysCalculated"
                      label="Dage"
                      v-slot="props">
        {{ props.row.daysCalculated }}
      </b-table-column>
    </b-table>
    <b-loading :is-full-page="isFullPage" :active.sync="saving" :can-cancel="true"></b-loading>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment, { ISO_8601 } from 'moment';
import APISTATE from '../../enums/APISTATE';
import YearPanel from '@/components/report/YearPanel.vue';
import SubmitPanel from '@/components/report/SubmitPanel.vue';

export default {
  name: "agreementw-view",
  components: { SubmitPanel, YearPanel },
  data: () => ({ 
    isFullPage: true,
    saving: false
  }),
  async mounted() {
    // TODO
  },
  computed: {
    ...mapGetters("agreementStore", ["agreementsApiState", "agreements"]),
     loading() {
      return this.agreementsApiState === APISTATE.LOADING;
    },
  },
  methods: {
    ...mapActions("agreementStore", ["agreementByYear", "startEditingAgreement"]),
    async performLookup() {
      const dto = {
        year: this.year,
        forUser: this.employeeId
      };
      await this.agreementByYear(dto);
    },
    async editClick(arg) {
      console.log(arg);
      this.startEditingAgreement(arg);
    },
    dateFormat(arg) {
        return moment(arg).format('YYYY-MM-DD');
    }
  },
};
</script>

<style lang="scss" scoped>
.users-view {
  .register-user {
    cursor: pointer;
    width: 100%;
  }
}

.table td {
  text-align: left !important;
}
</style>
